<template>
  <div class="demo daterange-field">

    <div class="py-5">
      <div class="form-group">
        <label> <img class="calImg" src="../../assets/calender2.png" alt="LiveRun"></label>
       
        <date-range-picker
          ref="picker"
          :opens="opens"
          :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd',customRangeLabel: 'Custom Range',}"
          :singleDatePicker="singleDatePicker"
          :timePicker="timePicker"
          :timePicker24Hour="timePicker24Hour"
          :showWeekNumbers="showWeekNumbers"
          :showDropdowns="showDropdowns"
          :autoApply="autoApply"
          v-model="dateRange"
          :ranges="show_ranges ? ranges : false"
          @update="updateValues"
          @toggle="checkOpen"
          :linkedCalendars="linkedCalendars"
          :always-show-calendars="false"
          :alwaysShowCalendars="alwaysShowCalendars"
        >
          <div slot="input" slot-scope="picker" style="min-width: 350px;">
            {{ picker.startDate | date }} - {{ picker.endDate | date }}
          </div>
        </date-range-picker>

        
      </div>
    </div>

    
  </div>
</template>

<script>
  //import DateRangePicker from '../../../src/components/DateRangePicker'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'

  export default {
    components: {DateRangePicker},
    name: 'dateRangeField',
    filters: {
      date (value) {
        if (!value)
          return ''

        let options = {year: 'numeric', month: 'long', day: 'numeric'}
        return Intl.DateTimeFormat('en-US', options).format(value)
      }
    },
    data () {
      //                    :locale-data="{ daysOfWeek: [ 'Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб' ] }"
      return {
        opens: 'right',
        dateRange: {
          startDate: moment().startOf('month'),
          endDate:  moment().endOf('month'),
        },
        show_ranges: true,
        singleDatePicker: false,
        timePicker: false,
        timePicker24Hour: false,
        showDropdowns: true,
        autoApply: true,
        showWeekNumbers: true,
        // linkedCalendars: true,
        linkedCalendars: false,
        alwaysShowCalendars: false,

         ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
               //WORK FOR 0.4.0 VERSION
               // 'Today': [moment(), moment()],
                // 'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                // 'This week': [moment().startOf('week'),moment()],
                // 'Last week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                // 'This month': [moment().startOf('month'), moment().endOf('month')],
                // 'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                // 'Last 30 days':[moment().subtract(30, 'days'),moment().subtract(1, 'days')],
                // 'Last 90 days':[moment().subtract(90, 'days'),moment().subtract(1, 'days')],
                // // 'This year': [moment().startOf('year'), moment().endOf('year')],  
                // 'This year (Jan - Today)': [moment().startOf('year'), moment()],  
                
                'Today': [moment().toDate(), moment().toDate()],
                'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
                'This week': [moment().startOf('week').toDate(),moment().toDate()],
                'Last week': [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
                'This month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
                'Last month': [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()],
                'Last 30 days':[moment().subtract(30, 'days').toDate(),moment().subtract(1, 'days').toDate()],
                'Last 90 days':[moment().subtract(90, 'days').toDate(),moment().subtract(1, 'days').toDate()],
                // 'This year': [moment().startOf('year'), moment().endOf('year')],  
                'All Time (3 year ago - Today)': [moment().subtract(3, 'years').toDate(), moment().toDate()],
                'This year (Jan - Today)': [moment().startOf('year').toDate(), moment().toDate()],  
                
              }
      }
    },
    mounted () {
      // this.$refs.picker.open = true
    },
    methods: {
      updateValues (values) {
        //console.log('event: update', {...values})
        // this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD')
        // this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD')
        this.dateRange.startDate =moment(values.startDate).startOf('day').toISOString()
        this.dateRange.endDate = moment(values.endDate).endOf('day').toISOString()
        this.$emit('input', this.dateRange)
      },
      checkOpen (open) {
        //console.log('event: open', open)
      },
      dateFormat (classes, date) {
        // let yesterday = moment().subtract(1, 'day')
        // if (!classes.disabled) {
        //   classes.disabled = moment(date).isSame(yesterday, 'day')
        // }
        // return classes
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  a {
    color: #42b983;
  }

  small.form-text {
    display: initial;
  }
  
  small.form-text::before {
    content: ' - ';
  }
  .daterange-field{
    float: left;
    width: 50%
  }
</style>





// WEBPACK FOOTER //
// DateRangeField.vue?38ab897a